import {GET_NOTIFICATION_LIST_DATA,CLEAR_NOTITFICATION_LIST_DATA,UPDATE_NOTIFICATION_LIST_DATA,UPDATE_NOTIFICATION_LIST_ALL_DATA, REMOVE_READ_NOTIFICATIONS} from "../../constants/headerNotification/getNotificationConst"

const initalState={
    notificationListData:[],
    totalNotificationCount:0,
    loadedNotificationCount:0,
    notificationListPage:0,
    emptyNotificationList:false
}

export default function getNotificationListreducer(state=initalState , action){
   
    switch (action.type) {
        case GET_NOTIFICATION_LIST_DATA:
           const temp=(state.notificationListData).concat(action?.payload?.data?.notifications);
           console.log("temppppp",temp)
           return {
            ...state,
            notificationListData:temp,
            totalNotificationCount:action?.payload?.data?.totalRecords,
            notificationListPage:state.notificationListPage + 1 ,
            loadedNotificationCount:temp?.length
           };
          
        case CLEAR_NOTITFICATION_LIST_DATA:
           return {
                ...state,
                notificationListData:[],
                totalNotificationCount:0,
                notificationListPage:0,
                loadedAppointmentCount:0
            }

        case UPDATE_NOTIFICATION_LIST_DATA:

        let updateNotificationListData=state?.notificationListData?.map((item)=>{
            if(item.id==action.payload){
                return {...item,is_read:true}
            }
            else{
                return item
            }
        })
        return{
                ...state,
                notificationListData:updateNotificationListData
        }

        case UPDATE_NOTIFICATION_LIST_ALL_DATA:
             console.log("notiklsfj",state)
            return{
                ...state,
                notificationListData:state.notificationListData.map((item)=>({
                    ...item,
                    is_read:true
                }))
                
            }

        case REMOVE_READ_NOTIFICATIONS:
            const updatedNotificationListData = state?.notificationListData?.filter(
                (item) => item.id !== action.payload
            );
            return {
                ...state,
                notificationListData: updatedNotificationListData,
            };
        default:
           return state
    }
}